import React from "react";
import { isMobile } from "react-device-detect";

import MonitoringReportsMobile from "./MonitoringReportsMobile";
import MonitoringReportsDesktop from "./MonitoringReportsDesktop";

function MonitoringReports(props) {
  return isMobile ? <MonitoringReportsMobile {...props} /> : <MonitoringReportsDesktop {...props} />;
}

export default MonitoringReports;
